<p-confirmdialog #cd>
  <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
    <div class="align-items-center d-flex flex-column p-5 confirm-popup">
      <svg-icon [name]="message.icon"></svg-icon>
      <div class="d-flex align-items-center mb-2">
        <h1 class="fw-600 mt-4 mb-2 text-center text-secondary">{{ message.header }}</h1>
      </div>
      <p class="h3 fw-400 mb-4 text-center text-secondary">{{ message.message }}</p>
      <div class="d-flex justify-content-center gap-3">
        @if (rejectLabel) {
          <p-button
            [label]="rejectLabel"
            [raised]="true"
            styleClass="btn btn-shadow px-4"
            severity="secondary"
            [outlined]="true"
            (onClick)="onReject()"
            role="button"
          ></p-button>
        }
        <p-button
          role="button"
          [label]="acceptLabel"
          [raised]="true"
          [styleClass]="acceptSeverity === 'danger' ? 'btn btn-danger px-4' : 'btn btn-primary px-4'"
          [severity]="acceptSeverity"
          (onClick)="onAccept()"
        ></p-button>
      </div>
    </div>
  </ng-template>
</p-confirmdialog>
